import * as React from 'react'

import {
  Box,
  Center,
  Collapse,
  Fade,
  Flex,
  HStack,
  Link,
  VisuallyHidden,
  useColorModeValue as mode,
  useBoolean,
  useDisclosure
} from '@chakra-ui/react'

import { AiOutlineUser } from 'react-icons/ai'
import { Banner } from "./Banner"
import { CartCount } from './CartCount'
import Headroom from 'react-headroom'
import { Logo } from '../Logo/Logo'
import { MdMenu } from 'react-icons/md'
import { MobileBottomNav } from './MobileBottomNav'
import { NavAction } from './NavAction'
import { NavCategoryMenu } from './NavCategoryMenu'
import { NavCategorySubmenu } from './NavCategorySubmenu'
import { RiShoppingCartLine } from 'react-icons/ri'
import { SearchInput } from './SearchInput'
import styled from 'styled-components'
import { useAppState } from '../context'
import useAuth from '../hooks/useAuth'

const Div = styled.div`
.headroom {
  top: 0;
  left: 0;
  right: 0;
  zIndex: 1;
}
.headroom--unfixed {
  position: relative;
  transform: translateY(0);
}
.headroom--scrolled {
  transition: transform 200ms ease-in-out;
}
.headroom--unpinned {
  position: fixed;
  transform: translateY(-100%);
}
.headroom--pinned {
  position: fixed;
  transform: translateY(40px)!important;
  section  {
    top: -40px;
    position: relative;
  }
}
`

const Header = () => {
  const { cart } = useAppState()
  const { loggedIn, user } = useAuth();

  // const { isOpen, onOpen, onClose } = useDisclosure();
  const mobileNav = useDisclosure();
  const [flag, setFlag] = useBoolean();

  if (typeof window !== 'undefined') {
    //here `window` is available, so `window.document` (or simply `document`) is available too
    if (flag) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }
  
  return (
    <Div>
    <Banner></Banner>
    <Flex direction="column" overflow="hidden" display={{ base: 'flex', lg: 'none' }}>
      <Box px="4" py="4" borderBottomWidth="1px" overflow="auto">
        <Flex align="center" justify="space-between" mb="3" display={{ base: 'flex', lg: 'none' }}>
          <HStack spacing="3">
            <Center w="8" h="8" as="button" type="button">
              <VisuallyHidden>Toggle Menu</VisuallyHidden>
              <Box as={MdMenu} fontSize="3xl" onClick={setFlag.toggle}> </Box>
            </Center>
            <Link href='/'>
              <Logo h="40px" />
            </Link>
          </HStack>
        </Flex>
        <SearchInput />
        </Box>
        {flag ? (
          <Fade in={flag}>
          <Flex id="mobileNavContainer" justifyContent='space-between' flex="1" fontSize="sm" overflow="auto" height="100%" width="100%" position="absolute" zIndex="9" top={{ base: '217px', sm: "165px" }}  >
          <NavCategoryMenu.Mobile />
            <NavCategorySubmenu.Mobile /> 
                
      </Flex> </Fade>) : <></> }
        {/* <Flex id="mobileNavContainer" justifyContent='space-between' flex="1" fontSize="sm" overflow="auto" height="100%" width="100%" position="absolute" zIndex="9" top={{base: '217px', sm:"165px"}}  >
          {flag ? ( <Fade in={flag}><NavCategoryMenu.Mobile /></Fade>) : ""}
          {flag ? ( <NavCategorySubmenu.Mobile /> ) : ""}   
      </Flex> */}
      <MobileBottomNav />
    </Flex>
    <Box display={{ base: 'none', lg: 'block' }}>
     <Headroom
          onPin={() => console.log('pinned')}
          onUnpin={() => console.log('unpinned')}
          // wrapperStyle={{ marginBottom: rhythm(1) }}
          style={{

          }}
        >
      <Box px="8" bg="white">
        <Flex height="4.5rem" align="center" maxW="8xl" mx="auto">
          <HStack flex="24rem" spacing="32px">
            <Link href="/">
              <Logo h="40px" />
            </Link>
            
          </HStack>
          <Box width="full" mx="8">
            <SearchInput />
           
          </Box>
          <HStack spacing="8" flexShrink={0}>
              {!loggedIn ?
                (<NavAction.Desktop label="Sign In | Create New Account" href="/log-in" icon={AiOutlineUser} />) :
                (<NavAction.Desktop label={user?.firstName == null ? "Customer" : user.firstName} href="/acc-settings" icon={AiOutlineUser} />)}
           
              {!loggedIn ? (
            ''
            ) : (
              <Box position="relative">
              <NavAction.Desktop label="Cart" href="/cart" icon={RiShoppingCartLine} />
              <CartCount>{cart?.contents.itemCount || 0}</CartCount>
            </Box>
            )}
           
          </HStack>
        </Flex>
      </Box>
      </Headroom>    
        <NavCategoryMenu.Desktop />
      
      {/* <NavCategorySubmenu.Desktop /> */}
      <Box bg="blackAlpha.400" pos="fixed" zIndex="-1" inset="0" />  
    </Box>
  </Div>
    )
}

export default Header